/*!
 * Animate On Scroll entry for templates that render `aos-script`.
 * Imports the vendored AOS 2.3.1 ES module; no global is set.
 * Module scripts run after parsing, so AOS.init's DOMContentLoaded start
 * event sees readyState "interactive" and refreshes immediately — the same
 * timing as the former inline DOMContentLoaded handler.
 */
import AOS from './aos.esm.js';

AOS.init({
  once: true, // whether animation should happen only once - while scrolling down
  duration: 800,
  easing: 'ease-out-quad',
});

export default AOS;
